import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import {Row, Col, Label} from 'reactstrap';
import LoadingImage from "../../../comum/components/LoadingImage";
import Checkbox from '../../../comum/components/Checkbox'
import FormSelectSimples from "../../../comum/components/FormSelectSimples";
import {IconeDelete} from "../../../comum/components/Icones";
import FormInputSimples from "../../../comum/components/FormInputSimples";
import {buscaSemResultado} from "../../../../utils/mensagens";
import CheckboxArea from "../../../comum/components/CheckboxArea";

@inject("store")
@observer
export class AreaSelecaoNCMs extends Component{

    constructor(props) {
        super(props);
        this.appStore = this.props.store.appStore;

        this.controllerCadastrar = this.props.controller;
    };

    // Tabela
    headerTableSelecaoNCM = (sizeColumn) => {
        return  <Row className="header-row">
                    <Col xs={1} sm={1} md={1} lg={1} xl={1}>
                        <Checkbox onClick={ () => this.controllerCadastrar.marcarTodosNCM() } 
                                ativo={ this.controllerCadastrar.todosNCMsMarcados } 
                                bloqueado={this.props.bloqueado}
                        />
                    </Col>
                    <Col xs={sizeColumn} sm={sizeColumn} md={sizeColumn} lg={sizeColumn} xl={sizeColumn}>
                        <Label className="header-label">
                            NCMs
                        </Label>
                    </Col>            
                </Row>;
    };

    dataTableSelecaoNCM = (sizeColumn) => {
        return this.controllerCadastrar.ncms.map((ncm, index) =>
            <Row key={ncm.MercId} className="row-lista formulario">
                <Col xs={1} sm={1} md={1} lg={1} xl={1}>
                    <Checkbox onClick={ () => this.controllerCadastrar.marcarNCM(ncm) } 
                              ativo={ncm.marcado}
                              bloqueado={this.props.bloqueado}
                    />
                </Col>
                <Col xs={sizeColumn} sm={sizeColumn} md={sizeColumn} lg={sizeColumn} xl={sizeColumn}>
                    <Label>
                        {ncm.MercId}
                    </Label>
                </Col>                
            </Row>)
    };
    // FIM Tabela

    // Lista de cards
    listaCards = () => {
        return this.controllerCadastrar.ncms.map((ncm, index) =>
            <Row key={ncm.CodCntr} className="card-detalhe formulario">
                <CheckboxArea xs={12} sm={12} md={12} lg={12} xl={12}
                              mensagem={ <Label className="label-disabled">{ ncm.MercId }</Label> }
                              checked={ ncm.marcado }
                              onClick={ () => this.controllerCadastrar.marcarNCM(ncm) } 
                              bloqueado={this.props.bloqueado}
                />                
            </Row>)
    };
    // FIM Lista de cards

    tabela = (sizeColumn) => {
        if (!this.controllerCadastrar.salvando)
        {
            if (!this.appStore.isMobile()) {
                return <React.Fragment>
                        { this.headerTableSelecaoNCM(sizeColumn) }
                        { this.dataTableSelecaoNCM(sizeColumn) }
                    </React.Fragment>
            } else {
                return this.listaCards();
            }
        }        
    };

    render() {
        const sizeColumn = this.controllerCadastrar.parametrosDeCampos.selectNotas ? 3 : 4;
        return <div className="area-selecao-container">               
                    <div className="tabela-home-made">
                        { this.controllerCadastrar.loadingNCMs ? <LoadingImage />
                            : <React.Fragment>
                                { (!this.controllerCadastrar.ncms || this.controllerCadastrar.ncms.length===0)
                                    ? <Row>
                                        <Col xs={12}>
                                            <span className="mensagem-filtrar">
                                                { buscaSemResultado }
                                            </span>
                                        </Col>
                                    </Row>
                                    : <React.Fragment>
                                        { this.tabela(sizeColumn) }
                                    </React.Fragment>
                                }
                            </React.Fragment>
                        }
                    </div>
            </div>;
    }
}


// WEBPACK FOOTER //
// ./src/modules/agendamentoservicosTotal/cadastrar/components/AreaSelecaoNCMs.js